import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Instrument } from '../../plan/models/instrument';
import { map } from 'rxjs/operators';
import { HttpService } from './http.service';
import { NOT_CANCELLED_HEADER } from '../interceptors/auth.interceptor';

type RequestInstrument = {
	position_x: number;
	position_y: number;
	rotation: number;
	planogram: number;
	device_type: string;
	depth: number;
	width: number;
	name: string;
	terminal: number;
	client_updated_at: string;
}

export interface IDevice {
	created_at: string;
	updated_at: string;
	client_updated_at: string;
	depth: number;
	device_type: string;
	id: number;
	name: string;
	planogram: number;
	position_x: number;
	position_y: number;
	rotation: number;
	terminal: number;
	width: number;
}

const ROOT_URL: string = 'api/layout/devices/';

@Injectable({
	providedIn: 'root'
})
export class InstrumentsService {

	static getRequestInstrumentInfo(instrument: Instrument, planId: number): RequestInstrument {
		return {
			position_x: instrument.x,
			position_y: instrument.y,
			rotation: instrument.angle,
			planogram: planId,
			device_type: instrument.type,
			depth: instrument.depth,
			width: instrument.width,
			name: instrument.name,
			terminal: instrument.terminalId,
			client_updated_at: instrument.client_updated_at
		};
	}

	constructor(
		private http: HttpClient,
		private httpService: HttpService
	) {}

	get(planId: number): Promise<Array<IDevice>> {
		return this.httpService.getPromise<Array<IDevice>>(
			this.http.get<Array<IDevice>>(ROOT_URL, {
				params: new HttpParams({
					fromObject: { planogram_id: planId }
				})
			})
		);
	}

	create(instrument: Instrument, planId: number): Promise<Instrument> {
		return new Promise<Instrument>((resolve, reject) => {
			this.http.post<IDevice>(
                ROOT_URL, 
                InstrumentsService.getRequestInstrumentInfo(instrument, planId), 
                { headers: new HttpHeaders().set(NOT_CANCELLED_HEADER, 'true') }
            )
				.pipe(
					map((response: IDevice) => {
						instrument.id = response.id;
						return instrument;
					})
				)
				.subscribe({
					next: (instrument: Instrument) => resolve(instrument),
					error: (err: Error) => reject(err)
				});
		});
	}

	delete(instrument: Instrument): Promise<any> {
		return new Promise<any>((resolve, reject) => {
			this.http.delete<any>(ROOT_URL + `${instrument.id}/`, { observe: 'response', headers: new HttpHeaders().set(NOT_CANCELLED_HEADER, 'true') })
				.subscribe({
					next: (response: any) => resolve(response),
					error: (err: Error) => reject(err)
				});
		});
	}

	update(instrument: Instrument, planId: number): Promise<IDevice> {
		return new Promise<IDevice>((resolve, reject) => {
			this.http.put<IDevice>(
                ROOT_URL + `${instrument.id}/`, 
                InstrumentsService.getRequestInstrumentInfo(instrument, planId),
                { headers: new HttpHeaders().set(NOT_CANCELLED_HEADER, 'true') }
            )
				.subscribe({
					next: (res: IDevice) => resolve(res),
					error: (err: Error) => reject(err)
				});
		});
	}
}